import { render, staticRenderFns } from "./SettingWalletDeposit.vue?vue&type=template&id=c4fa3eca&"
import script from "./SettingWalletDeposit.vue?vue&type=script&lang=js&"
export * from "./SettingWalletDeposit.vue?vue&type=script&lang=js&"
import style0 from "./SettingWalletDeposit.vue?vue&type=style&index=0&id=c4fa3eca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports